import { useContext, useRef, useEffect } from 'react';
import {AuthContext, AlertContext, ClientContext} from '../services'

const useAuth = () => useContext(AuthContext);
const useAlert =() => useContext(AlertContext)
const useClient = () => useContext(ClientContext)

const  usePrevious = (value) => {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
}


export {useAuth, useAlert, useClient, usePrevious}
export * from './useLocalStorage'
export * from './toaster'